<!--能耗计算对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? '修改-规则' : '创建-规则'" :has-form="true" class="time-event-dialog-modal" top="15%" width="30%"
      @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="description">
              </el-input>
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="执行方式" name="second">
          <div class="border-main">
            <gs-form :model="rulemodel">
              <gs-form-item label="执行方式">
                <gs-select v-model="rulemodel.executeType" size="mini">
                  <gs-option v-for="item in executeArray" :key="item.value" :label="item.label" :value="item.value">
                  </gs-option>
                </gs-select>
              </gs-form-item>
              <fieldset>
                <legend>定时执行时间选择</legend>
                <gs-form-item label="" prop="target" class="form-item-radio">
                  <gs-checkbox-group v-model="rulemodel.checkedCities">
                    <gs-checkbox v-for="city in cities" :label="city" :key="city" style="margin:10px">{{ city
                      }}</gs-checkbox>
                  </gs-checkbox-group>
                </gs-form-item>
                <div style="width: 100%;display: flex;justify-content: center;align-items: center;">
                  <span style="font-size: 12px;">开始时间：</span>
                  <gs-time-picker v-model="rulemodel.startTime" format="HH:mm" />
                  <span style="font-size: 12px;margin-left: 20px;">结束时间：</span>
                  <gs-time-picker v-model="rulemodel.endTime" format="HH:mm" />
                </div>
              </fieldset>
            </gs-form>
          </div>
        </gs-tab-pane>
        <gs-tab-pane label="执行规则" name="end">
          <div style="width: 100%;display: flex;align-items: center;margin-bottom: 10px;padding-left: 15px;">
            <span style="font-size: 12px;">添加规则</span>
            <gs-button type="primary" size="mini" style="margin-left: 20px;" @click="addForm">添加</gs-button>
          </div>
          <div style="width: 100%;height: 360px;overflow: auto;">
            <fieldset style="margin-bottom: 20px;" v-for="(item, index) in ruleListArray" :key="index">
              <legend style="color: #FF7F00;">规则设置</legend>
              <gs-form :model="ruleFrom" label-width="90px" label-position="left" gap="small">
                <gs-form-item label="选择类型" prop="target" class="form-item-radio">
                  <gs-select v-model="item.type" size="mini">
                    <gs-option v-for="item in ruleArray" :key="item.value" :label="item.label" :value="item.value">
                    </gs-option>
                  </gs-select>
                </gs-form-item>
                <gs-form-item label="输入点位" prop="target" class="form-item-radio">
                  <gs-input ref="nameInput" v-model="item.pointName" placeholder="子设备+名称 例如：FAN1:BW_FAN_ON(冒号为英文冒号)" />
                </gs-form-item>
                <gs-form-item label="输入数值" prop="target" class="form-item-radio">
                  <gs-input ref="nameInput" v-model="item.value" placeholder="如果值输入多个请用英文逗号隔开" />
                </gs-form-item>
                <gs-form-item label="是否生成报告" prop="target" class="form-item-radio">
                  <gs-select v-model="item.isReport" size="mini">
                    <gs-option v-for="item in reportArray" :key="item.value" :label="item.label" :value="item.value">
                    </gs-option>
                  </gs-select>
                </gs-form-item>
                <gs-form-item label="是否执行" prop="target" class="form-item-radio">
                  <gs-select v-model="item.isExecute" size="mini">
                    <gs-option v-for="item in reportArray" :key="item.value" :label="item.label" :value="item.value">
                    </gs-option>
                  </gs-select>
                </gs-form-item>
                <gs-form-item label="执行的值" prop="target" class="form-item-radio">
                  <gs-input ref="nameInput" v-model="item.executeValue" placeholder="如果“是否执行”选择为“是”，那此字段必须填写" />
                </gs-form-item>
                <gs-form-item label="报告内容" prop="target" class="form-item-radio">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="item.reportContext">
                  </el-input>
                </gs-form-item>
                <gs-form-item label="子规则" prop="target" class="form-item-radio">
                  <gs-button type="primary" size="mini" @click="sonRuleShow = true">添加</gs-button>
                  <gs-button type="primary" size="mini" @click="delRuleSonAll(index)">删除</gs-button>
                </gs-form-item>
                <gs-form-item label="删除当前规则" prop="target" class="form-item-radio" v-if="index != 0">
                  <gs-button type="primary" size="mini" @click="delRule(index)">删除</gs-button>
                </gs-form-item>
              </gs-form>
            </fieldset>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
      </span>
    </gs-modal>

    <gs-modal v-model="sonRuleShow" title="子规则设置" width="30%" :before-close="beforeCloseSon"
      :before-confirm="beforeCloseSon" @confirm="beforeCloseSon" class="time-event-dialog-modal" top="15%">
      <div style="width: 100%;height: 360px;overflow: auto;">
        <div style="width: 100%;display: flex;align-items: center;margin-bottom: 10px;padding-left: 15px;">
          <span style="font-size: 12px;">添加子规则</span>
          <gs-button type="primary" size="mini" style="margin-left: 20px;" @click="addSonForm">添加</gs-button>
        </div>
        <fieldset style="margin-bottom: 20px;" v-for="(itemson, index) in ruleListSonArray" :key="index">
          <legend style="color: #FF7F00;">子规则设置</legend>
          <gs-form :model="ruleFromSon" label-width="90px" label-position="left" gap="small">
            <gs-form-item label="选择类型" prop="target" class="form-item-radio">
              <gs-select v-model="itemson.type" size="mini">
                <gs-option v-for="item in ruleArray" :key="item.value" :label="item.label" :value="item.value">
                </gs-option>
              </gs-select>
            </gs-form-item>
            <gs-form-item label="输入点位" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="itemson.pointName" placeholder="子设备+名称 例如：FAN1:BW_FAN_ON(冒号为英文冒号)" />
            </gs-form-item>
            <gs-form-item label="输入数值" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="itemson.value" placeholder="如果值输入多个请用英文逗号隔开" />
            </gs-form-item>
            <gs-form-item label="是否生成报告" prop="target" class="form-item-radio">
              <gs-select v-model="itemson.isReport" size="mini">
                <gs-option v-for="item in reportArray" :key="item.value" :label="item.label" :value="item.value">
                </gs-option>
              </gs-select>
            </gs-form-item>
            <gs-form-item label="是否执行" prop="target" class="form-item-radio">
              <gs-select v-model="itemson.isExecute" size="mini">
                <gs-option v-for="item in reportArray" :key="item.value" :label="item.label" :value="item.value">
                </gs-option>
              </gs-select>
            </gs-form-item>
            <gs-form-item label="执行的值" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="itemson.executeValue" placeholder="如果“是否执行”选择为“是”，那此字段必须填写" />
            </gs-form-item>
            <gs-form-item label="报告内容" prop="target" class="form-item-radio">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="itemson.reportContext">
              </el-input>
            </gs-form-item>
            <gs-form-item label="删除当前规则" prop="target" class="form-item-radio" v-if="index != 0">
              <gs-button type="primary" size="mini" @click="delSonRule(index)">删除</gs-button>
            </gs-form-item>
          </gs-form>
        </fieldset>
      </div>
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import moment from 'moment'
export default {
  components: {

  },
  data() {
    return {
      ruleListArray: [
        {
          type: '',
          pointName: "",
          value: '',
          reportContext: "", // 报告内容
          isReport: false, // 是否生成报告
          isExecute: false,
          executeValue: "",
          subRules: [
          ],
        },
      ],
      ruleListSonArray: [
        {
          type: '',
          pointName: "",
          value: '',
          reportContext: "", // 报告内容
          isReport: false, // 是否生成报告
          isExecute: false,
          executeValue: "",
        },
      ],
      loading: false,
      activeName: 'first',
      name: '',
      description: '',
      isEdit: false,
      rulemodel: {
        executeType: 'schedule',
        checkedCities: ['星期一', '星期二', '星期三', '星期四', '星期五'],
        startTime: moment(),
        endTime: moment()
      },
      executeArray: [
        {
          label: "定时执行",
          value: "schedule"
        },
        {
          label: "点击执行",
          value: "click"
        },
      ],
      cities: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      ruleFrom: {
        type: '',
        pointName: "",
        value: '',
        reportContext: "", // 报告内容
        isReport: false, // 是否生成报告
        isExecute: false,
        executeValue: ""
      },
      ruleFromSon: {
        type: '',
        pointName: "",
        value: '',
        reportContext: "", // 报告内容
        isReport: false, // 是否生成报告
        isExecute: false,
        executeValue: ""
      },
      ruleArray: [
        {
          label: "等于",
          value: "EQUAL"
        },
        {
          label: "不等于",
          value: "UNEQUAL"
        },
        {
          label: "被包含",
          value: "IN"
        },
        {
          label: "不被包含",
          value: "NOTIN"
        },
        {
          label: "小于",
          value: "LT"
        },
        {
          label: "大于",
          value: "GT"
        },
        {
          label: "小于或大于",
          value: "LTORGT"
        },
        {
          label: "大于且小于",
          value: "GTANDLT"
        },
      ],
      reportArray: [
        {
          label: "是",
          value: true
        },
        {
          label: "否",
          value: false
        }
      ],
      sonRuleShow: false,
    }
  },
  computed: {
    ...mapState({
      visible: 'ruleDialogShow',
      nodeData: 'nodeTree',
      objectData: 'objectInfo'
    })
  },
  watch: {
    visible() {
      if (this.visible) {
        this.isEdit = true
        this.activeName = 'first'
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'EnergyCalculation') {

        } else {

        }
      } else {

      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'RULE_DIALOG_HIDE'
    }),
    //主
    beforeClose() {
      this.close()
    },
    handleConfirm() {
      let _this = this
      console.log(this.ruleListArray)
    },
    beforeConfirm(e, done) {

    },
    // 深拷贝
    cloneObj(obj) {
      let ret;
      if (Array.isArray(obj)) {
        //创建一个空数组 
        ret = [];
        for (let i = 0; i < obj.length; i++) {
          ret[i] = this.cloneObj(obj[i]);
        }
        return ret;
      } else if (Object.prototype.toString.call(obj) === "[object Object]") {
        ret = {};
        for (let i in obj) {
          ret[i] = this.cloneObj(obj[i]);
        }
        return ret;
      } else {
        return obj;
      }
    },
    // 添加规则
    addForm() {
      let arr = this.cloneObj(this.ruleFrom);
      this.ruleListArray.push(arr);
    },
    // 删除规则
    delRule(index) {
      this.ruleListArray.splice(index, 1)
    },
    delSonRule(index) {
      this.ruleListSonArray.splice(index, 1)
    },
    // 关闭子规则窗口
    beforeCloseSon() {
      this.sonRuleShow = false
    },
    // 添加子规则
    addSonForm() {
      let arr = this.cloneObj(this.ruleFromSon);
      this.ruleListSonArray.push(arr);
    },
    // 删除所有子规则
    delRuleSonAll() {
      // 删除所有子规则
      console.log(this.ruleListArray)
      console.log(this.ruleListSonArray)
    }
  }
}
</script>
<style>
/* .gs-form-item {
  margin-bottom: 0px !important;
} */
</style>
<style scoped>
.inp>>>.gs-input,
.gs-input-number {
  height: 26px;
}

.gs-modal-wrap {
  top: 11%;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.seventy-part {
  box-sizing: border-box;
  float: left;
  width: 65%;
}

.thirty-part {
  box-sizing: border-box;
  float: left;
  width: 100%;
}

.event-btn {
  margin: 10px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 250px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.form-item-objectSeries>>>.gs-form-item {
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/other/ruleDialog.vue